<template>
<div class="mx-3">
    <div v-if="claim.has_historical_documents && !claim.has_non_historical_documents" class="alert alert-primary text-center" role="alert">
        <h5><i class="fas fa-history"></i> Historical</h5>       
    </div>        
    <div v-if="showHistoricalToggle" class="d-flex justify-content-end align-items-end">
        <div class="btn-group btn-group-sm btn-group-toggle mb-1" data-toggle="buttons">
            <label :class="['btn-state btn btn-secondary', {'active': historicalState === HistoricalState.ALL}]">
                <input type="radio" autocomplete="off" :value="HistoricalState.ALL" :checked="historicalState === HistoricalState.ALL" @change="changeState($event.target)"> All
            </label>
            <label :class="['btn-state btn btn-secondary', {'active': historicalState === HistoricalState.NONE}]">
                <input type="radio" autocomplete="off" :value="HistoricalState.NONE" :checked="historicalState === HistoricalState.NONE" @change="changeState($event.target)"> No Historical
            </label>
            <label :class="['btn-state btn btn-secondary', {'active': historicalState === HistoricalState.ONLY}]">
                <input type="radio" autocomplete="off" :value="HistoricalState.ONLY" :checked="historicalState === HistoricalState.ONLY" @change="changeState($event.target)"> Historical Only
            </label>                
        </div>
    </div>    
    <researcher-claim-detail :data-claim="claim"></researcher-claim-detail>
    <researcher-document-association-modal></researcher-document-association-modal>
    <researcher-filter-documents-modal></researcher-filter-documents-modal>
    <basic-submission-history-modal></basic-submission-history-modal>
    <document-disassociate-confirmation></document-disassociate-confirmation>
    <confirmation-modal></confirmation-modal>
    <researcher-service-documents id="researcher-services" :client-id="claim.client_id" :claim-id="claim.id" :href="servicesHref" :state="historicalState"></researcher-service-documents>
    <researcher-documents id="researcher-authorizations" :client-id="claim.client_id" :claim-id="claim.id" title="Authorizations" subtitle="LWC Form 1010" :href="authorizationsHref" :state="historicalState"></researcher-documents>   
    <researcher-documents id="researcher-eobs" :client-id="claim.client_id" :claim-id="claim.id" title="EOBs" :href="remitsHref" :state="historicalState"></researcher-documents>
    <researcher-documents id="researcher-correspondence" :client-id="claim.client_id" :claim-id="claim.id" title="Received Correspondence" :href="corsHref" :state="historicalState"></researcher-documents>
    <researcher-documents id="researcher-disputes" :client-id="claim.client_id" :claim-id="claim.id" title="Medical Treatment Disputes" subtitle="LWC Form 1009 Responses" :href="disputesHref" :state="historicalState"></researcher-documents>
    <researcher-documents id="researcher-other" :client-id="claim.client_id" :claim-id="claim.id" title="Other Documents" :href="othersHref" :state="historicalState"></researcher-documents>
    <claim-notes id="researcher-claim-notes" :claim-id="claim.id"></claim-notes>
    <document-tags></document-tags>
    <document-notes-modal></document-notes-modal>
    <file-upload-modal></file-upload-modal>
</div>     
</template>

<script>
import { HistoricalState } from '../../constants.js';
import ResearcherClaimDetail from './ResearcherClaimDetailComponent.vue';
import ResearcherDocumentAssociationModal from './ResearcherDocumentAssociationComponent.vue';
import ResearcherFilterDocumentsModal from './ResearcherFilterDocumentsComponent.vue';
import ResearcherServiceDocuments from './ResearcherServiceDocumentsComponent.vue';
import ResearcherDocuments from './ResearcherDocumentsComponent.vue';
import ClaimNotes from '../claims/ClaimNotesComponent.vue';
import DocumentTags from '../documents/DocumentTagsComponent.vue';
import DocumentNotesModal from '../documents/DocumentNotesModalComponent.vue';
import BasicSubmissionHistoryModal from '../transmissions/BasicSubmissionHistoryComponent.vue';
import DocumentDisassociateConfirmation from '../documents/DocumentDisassociateComponent.vue';

export default {
    components: {
        ResearcherClaimDetail,
        ResearcherDocumentAssociationModal,
        ResearcherFilterDocumentsModal,
        ResearcherServiceDocuments,
        ResearcherDocuments,
        ClaimNotes,
        DocumentTags,
        DocumentNotesModal,
        BasicSubmissionHistoryModal,
        DocumentDisassociateConfirmation
    },
    props: {
        claim: Object
    },
    data() {
        return {
            HistoricalState: HistoricalState,
            historicalState: HistoricalState.ALL,
            baseHref: `/ajax/researcher/clients/${this.claim.client_id}/claims/${this.claim.id}`
        }
    },
    computed: {
        showHistoricalToggle: function () {
            return this.claim.has_historical_documents && this.claim.has_non_historical_documents;
        },        
        servicesHref: function () {
            return `${this.baseHref}/services`;
        },
        authorizationsHref: function () {
            return `${this.baseHref}/authorizations`;
        },
        remitsHref: function () {
            return `${this.baseHref}/remits`;
        },
        corsHref: function () {
            return `${this.baseHref}/correspondences`;
        },
        disputesHref: function () {
            return `${this.baseHref}/disputes`;
        },
        othersHref: function () {
            return `${this.baseHref}/others`;
        }
    },
    methods: {
        changeState: function (target) {

            if (target && target.checked) {
                this.historicalState = parseInt(target.value);
            }
        }
    }  
}
</script>